import * as React from 'react';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { AmorgAdminPageProvider } from '../AmorgAdminPageContext';
import { H1 } from '../../../designSystem/typography/Heading';
import { ArticlesTab } from './_components/ArticlesTab';
import { ArticleTopicSubscriberListing } from '../../../amorg-common';
import { articlesClientApi } from '../../../api/articlesClientApi';
import { useLocation, useParams } from 'react-router-dom';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { FilteredArticleTable } from './_components/FilteredArticleTable';
import { AdminTab } from '../_components/AdminTab';

export default function ArticlesSubscriber (): JSX.Element 
{
    const { subscriberId } = useParams<{ subscriberId: string; }>();
    const [subscriberListing, setSubscriberListing] = React.useState<ArticleTopicSubscriberListing>(null);
    const [loading, setLoading] = React.useState<boolean>(true);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const listId = queryParams.get('lid'); // Replace 'someQueryParam' with your parameter name

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const subscribers = await articlesClientApi.getSubscriberListings();
            setSubscriberListing(subscribers.find(s => s.subscriberId === subscriberId));
            setLoading(false);
        };
        getData();
    }, []);

    return (
        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />
            <SingleColumnLayout
                wide
                noDivider
                headerContainer={
                    <Flex flexDirection='column' gap={16}>
                        <AdminTab selectedTab='articles' />
                        <Flex flexDirection='row' justifyContent='space-between'>
                            <ArticlesTab selectedTab='subscribers' />
                            <LinkButton variant='text' href="/amorgy/articles/subscribers" text="Tilbage til oversigten" />
                        </Flex>
                    </Flex>
                }

                contentContainer={
                    <Flex flexDirection="column" gap={16}>
                        <H1>Abonnement for {subscriberListing?.siteId || '...'}</H1>
                        <FilteredArticleTable subscriberId={subscriberId} listId={listId} preview goTo />
                    </Flex>
                }
            />

        </AmorgAdminPageProvider>
    );
}